export const Triangle = ({
  isFilled,
  isInverted,
}: {
  isFilled?: boolean;
  isInverted?: boolean;
}) => {
  const getStyle = () => {
    if (isInverted) {
      return 'rotate(180deg)';
    }
  };

  return (
    <svg
      style={{ transform: getStyle() }}
      width="16"
      height="22"
      viewBox="0 0 16 22"
      fill={isFilled ? 'black' : 'none'}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.6431 21.75H0.356925L8 0.731543L15.6431 21.75Z"
        stroke="black"
        strokeWidth="0.5"
      />
    </svg>
  );
};
